<template>
  <tr class="clinic-quotation">
    <td class="clinic-quotation__code">{{ quotation.code }}</td>
    <td class="clinic-quotation__date">{{ pretty_date }}</td>
    <td v-if="showclinic" class="clinic-quotation__clinic">{{ clinic_name }}</td>
    <td class="clinic-quotation__doctor">{{ status_name }}</td>
    <td class="clinic-quotation__customer">
      <a :href="customer_link">{{ customer_name }}</a>
    </td>
    <td class="clinic-quotation__quoted">{{ quoted }}</td>
    <td class="clinic-quotation__approved">{{ approved }}</td>
    <td class="clinic-quotation__done">{{ done }}</td>
    <td class="clinic-quotation__paid">{{ paid }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    quotation: { required: true },
    clinics: { default: null },
    doctors: { default: null },
    categories: { default: null },
    orderby: { default: null },
    showclinic: { default: false },
    core: { default: false },
  },
  computed: {
    net_price() {
      return WabiDent.fmtMoney(this.quotation.net_price)
    },
    approved_price() {
      return WabiDent.fmtMoney(this.quotation.approved_price)
    },
    customer_name() {
      if (!this.quotation.customer) return "";
      return this.customer.full_name;
    },
    customer_link() {
      if (!this.quotation.customer) return "";
      return `/customer/${this.quotation.customer.id}/edit`;
    },
    pretty_date() {
      let d = this.quotation.created_at;
      switch (this.orderby) {
        case "approved_at":
          d = this.quotation.approved_at;
          break;
      }
      if (d) {
        return moment(d).toDate().toLocaleDateString();
      }
      return "-";
    },
    status_name() {
      if (!this.quotation) return 'N/A';
      if (this.quotation.is_approved) return 'Aprobado';
      if (this.approved_lines.length) return 'Apr. Parcial';

      let now = moment();
      let expiry = moment(this.quotation.expiry_date);

      if (expiry < now) {
        return 'Caducado;'
      }

      return 'Pendiente';
    },
    doctor_name() {
      if (!this.doctors) return "";

      let doc = this.doctors.find((doc) => {
        return doc.doctor.id == this.quotation.assigned_doctor_id;
      });

      if (!doc) return "";
      return doc.name;
    },
    customer_name() {
      if (!this.quotation.customer) return "";
      return this.quotation.customer.full_name;
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.quotation.clinic_id] || "";
    },
    approved_lines() {
      if (!this.quotation) return [];

      return this.quotation.quotationlines.filter((line) => {
        return line.is_approved;
      });
    },
    quoted() {
      if (!this.quotation) return 0;

      let total = this.quotation.quotationlines.reduce((cur, val) => {
        return (
          cur +
          (Number(val.price) *
            Number(val.quantity) *
            (1 - Number(val.discount) / 100)) -
          val.abs_discount
        );
      }, 0);

      return WabiDent.fmtMoney(total);
    },
    approved() {
      if (!this.quotation) {
        return 0;
      }

      if (this.quotation.is_approved) {
        return this.quoted;
      }

      let total = this.approved_lines.reduce((cur, val) => {
        return (
          cur +
          (Number(val.price) *
            Number(val.quantity) *
            (1 - Number(val.discount) / 100)) -
          val.abs_discount
        );
      }, 0);

      return WabiDent.fmtMoney(total);
    },
    done() {
      let total = 0;
      console.log(this.quotation.treatments);

      this.quotation.treatments.forEach((t) => {
        if (t.status == 'done') {
          total += Number(t.quoted_price);
        }
      });
      return WabiDent.fmtMoney(total);
    },
    paid() {
      let total = 0;
      this.quotation.treatments.forEach((t) => {
        if (t.is_paid) {
          total += Number(t.quoted_price);
        }
      });
      return WabiDent.fmtMoney(total);
    },
  },
};
</script>

<style lang="scss"></style>
